import { FSP_CONFIG_CODE } from 'consts';
import PropTypes from 'prop-types';
import { useFSPImport } from '../hooks';

const FormikFSPConfigExpandablePanelContent = ({ children, format }) => {
  useFSPImport({ format, section: FSP_CONFIG_CODE });

  return children;
};

FormikFSPConfigExpandablePanelContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  format: PropTypes.func,
};

FormikFSPConfigExpandablePanelContent.defaultProps = {
  format: undefined,
};

export default FormikFSPConfigExpandablePanelContent;
